import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'

import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import Link from '@material-ui/core/Link'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import { addTestAutomationClassName } from 'utils/misc'
import SubmitButton from 'components/atoms/buttons/SubmitButton'

import { FORM_ACTION_ERROR_STATUS } from 'constants/form'

export const styles = theme => ({
  root: {
    textAlign: 'center',
    padding: `0 ${theme.spacing(1)}px`,
  },
  errorMessage: {
    padding: `${theme.spacing(2)}px 0`,
  },
  formControl: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  formControlButton: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(1),
  },
  hideMobile: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
})

const ResetForm = ({
  values,
  status,
  errors,
  classes,
  isSubmitting,
  errorMessage,
  hasFieldError,
  handleFormSubmit,
  handleFieldChange,
  className: classNameProp,
}) => {
  const className = classNames(classes.root, classNameProp)
  return (
    <div className={className}>
      {status === FORM_ACTION_ERROR_STATUS && errorMessage ? (
        <Typography
          className={classes.errorMessage}
          color="error"
          align="center">
          {errorMessage}
        </Typography>
      ) : null}
      <form noValidate autoComplete="off" onSubmit={handleFormSubmit}>
        <FormControl
          className={classes.formControl}
          fullWidth
          error={hasFieldError('email')}>
          <TextField
            id="email"
            name="email"
            label="Email Address"
            value={values.email}
            onChange={handleFieldChange}
            margin="normal"
            error={hasFieldError('email')}
            inputProps={{
              maxLength: 256,
            }}
            className={addTestAutomationClassName('qa-resetpassword-field-email')}
          />
          {hasFieldError('email') ? (
            <FormHelperText>{errors.email}</FormHelperText>
          ) : null}
        </FormControl>
        <FormControl className={classes.formControlButton} fullWidth>
          <SubmitButton
            autoFocus
            size="large"
            type="submit"
            color="primary"
            variant="primary"
            disabled={isSubmitting}
            className={addTestAutomationClassName('qa-resetpassword-button-resetpassword')}>
            Reset Password
          </SubmitButton>
        </FormControl>
        <FormControl
          className={classNames(classes.formControl, classes.hideMobile)}
          fullWidth>
          <Typography>
            Wrong place?{' '}
            <Link
              className={addTestAutomationClassName('qa-resetpassword-link-backtologin')}
              href="/login">
              Back to login
            </Link>
          </Typography>
        </FormControl>
      </form>
    </div>
  )
}

ResetForm.propTypes = {
  onReset: PropTypes.func,
  status: PropTypes.string,
  values: PropTypes.object,
  errors: PropTypes.object,
  rememberMe: PropTypes.bool,
  className: PropTypes.string,
  isSubmitting: PropTypes.bool,
  apiCallError: PropTypes.bool,
  hasFieldError: PropTypes.func,
  errorMessage: PropTypes.string,
  handleFormSubmit: PropTypes.func,
  handleFieldChange: PropTypes.func,
  handleCheckboxChange: PropTypes.func,
  classes: PropTypes.object.isRequired,
}

ResetForm.defaultProps = {}

export default withStyles(styles)(ResetForm)



// WEBPACK FOOTER //
// ./src/components/organisms/ResetForm/ResetForm.js